/* LXRY LP: Ideen-Slider. Progressive Enhancement: ohne JS bleibt der Slider per Wischen/Scrollen bedienbar. */
(function () {
  'use strict';
  function init(root) {
    var track = root.querySelector('.s-ideas-track');
    var ctl = root.querySelector('[data-lxry-slider-ctl]');
    if (!track || !ctl) return;
    var prev = ctl.querySelector('[data-lxry-slider-prev]');
    var next = ctl.querySelector('[data-lxry-slider-next]');
    var cur = ctl.querySelector('[data-lxry-slider-cur]');
    var slides = Array.prototype.slice.call(track.children);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    ctl.hidden = false;

    function step() {
      var a = slides[0], b = slides[1];
      return b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
    }
    function index() {
      var st = step();
      return st ? Math.round(track.scrollLeft / st) : 0;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
      var i = next.disabled ? slides.length : Math.min(slides.length, index() + 1);
      if (cur) cur.textContent = String(i);
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lxry-slider]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
